import { IconHeart } from "@tine/designsystem-icons/sharp";
import { observer } from "mobx-react-lite";

import useMediaQuery from "../common/useMediaQuery";
import { mediaQueries } from "../common/utils";

import Button from "./Button";

const FavoriteListButton = () => {
   return (
      <Button
         to="/customer/favorites"
         iconPosition="left"
         size="iconOnly"
         variant="tertiary"
         icon={<IconHeart />}
         aria-label="favorittlister"
         trackingName="Favorittlister"
         data-testid="go-to-favorite-list-menu-button"
      >
         {useMediaQuery(mediaQueries.xl) ? "Favorittlister" : ""}
      </Button>
   );
};

export default observer(FavoriteListButton);
